export class UnknownApiError extends Error {}
